const toRecentCompanyPref = (company) => {
  const pref = { ...company };
  delete pref.settings;
  return pref;
};

export default toRecentCompanyPref;
